.sections {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.assessmentSection {
    margin-top: 20px;
}

.fieldsRow {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.fieldsRow > * {
    flex: 1;
}

.datePickerAndRecommendation {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}

.assessmentHeaderRow {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    /* Counters the margin of the checkbox on the left of this row. Without this negative margin, the checkbox (and the entire "row" with the assessment's title) looks unnecessarily indented. */
    margin-left: -10px;
}

.questionCount {
    color: var(--hps-gray);
    font-weight: 500;
}